import { render } from "./MotionPathPlugin.vue?vue&type=template&id=a10caaf4"
import script from "./MotionPathPlugin.vue?vue&type=script&lang=js"
export * from "./MotionPathPlugin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__